import FitSVGText from '@/components/fit-svg-text/component'

export default {
  name: 'blossom-c',
  props: [ 'color' ],
  components: { FitSVGText },
  computed: {
    colorName () {
      if (this.color && this.color.name) {
        return this.color.name
      }
      return ''
    },

    // invertText adds a class which makes the bottom text white. It's used if the background is one of the dark ones
    // and the presentation is "full-size", otherwise placing black text on dark background.
    invertText () {
      let isFullsize = this.$store.getters.posterPresentation === 'fullsize'
      let isDarkBackground = [ 'burgundy', 'slate-grey' ].indexOf(this.colorName) !== -1
      return isFullsize && isDarkBackground
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/posters/blossom-c/script.js